import { render, staticRenderFns } from "./CardsCard.vue?vue&type=template&id=3bd2f996&"
import script from "./CardsCard.vue?vue&type=script&lang=js&"
export * from "./CardsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports